var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { participantsSelector, updateParticipant, } from '../../../../store/slices/participantSlice';
import { doRefreshWebcams } from '../../../../store/slices/roomSettingsSlice';
const PinWebcam = ({ userId }) => {
    _react_refresh_temp_2();
    const dispatch = useAppDispatch();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const togglePin = () => {
        dispatch(updateParticipant({
            id: userId,
            changes: {
                pinWebcam: !(participant === null || participant === void 0 ? void 0 : participant.pinWebcam),
            },
        }));
        dispatch(doRefreshWebcams());
    };
    const render = useMemo(() => {
        return (_jsx("div", { className: "pin-webcam cursor-pointer", onClick: togglePin, children: (participant === null || participant === void 0 ? void 0 : participant.pinWebcam) ? (_jsx("i", { className: "pnm-pin text-white text-[12px]" })) : (_jsx("i", { className: "pnm-pin -rotate-90 text-white text-[12px]" })) }));
    }, [participant === null || participant === void 0 ? void 0 : participant.pinWebcam]);
    return _jsx(_Fragment, { children: render });
};
_react_refresh_temp_1 = PinWebcam;
$RefreshReg$(_react_refresh_temp_1, "PinWebcam");
_react_refresh_temp_2(PinWebcam, "rZmCB1klsvkAKV6wcpQ85Yk9vNc=", false, () => [useAppDispatch, useAppSelector]);
export default PinWebcam;
